import { Component, inject, signal } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";
import { catchError, map, of } from "rxjs";
import { Constantes } from "src/app/shared/constantes";
import { ParametresService } from "src/app/shared/services/parametres.service";

/** Clé de sessionStorage : dernier message fermé par l'utilisateur. */
const CLE_MESSAGE_FERME = 'SIGT-BandeauAvis-Ferme';

/**
 * Alerte générale du SDG en tête de l'accueil (PES et intranet). Le message est piloté par
 * le paramètre BANDEAU_MSG_ACCUEIL (SIG_VALEU_PARAM) : aucune valeur active,
 * aucune alerte. Le message est affiché en texte brut.
 * Une fois fermée, l'alerte ne revient pas de la session, sauf si le message change.
 */
@Component({
  selector: 'app-bandeau-avis',
  templateUrl: './bandeau-avis.component.html',
  styleUrls: ['./bandeau-avis.component.scss'],
  imports: [
    MatButtonModule,
    MatIconModule,
    TranslateModule
  ]
})
export class BandeauAvisComponent {
  #parametresService = inject(ParametresService);

  message = signal<string | null>(null);

  constructor() {
    this.#parametresService.obtenirValeur(Constantes.Parametres.BandeauMessageAccueil).pipe(
      map(rep => rep.valeur?.trim().slice(0, Constantes.Parametres.BandeauMessageAccueilLongueurMax) || null),
      // 404 quand aucune valeur n'est active : pas d'alerte, pas d'erreur.
      catchError(() => of(null))
    ).subscribe(message => {
      if (message && message !== this.lireMessageFerme()) {
        this.message.set(message);
      }
    });
  }

  fermer(): void {
    try {
      sessionStorage.setItem(CLE_MESSAGE_FERME, this.message() ?? '');
    } catch { }
    this.message.set(null);
  }

  private lireMessageFerme(): string | null {
    try {
      return sessionStorage.getItem(CLE_MESSAGE_FERME);
    } catch {
      return null;
    }
  }
}
